import React from 'react';

import styled from '@emotion/styled';

import {
    // IParcelItem,
    ITrackPackageResponse,
} from '../../../models/trackPage/trackPackage.model';

interface IParcelContent {
    trackingInfo?: ITrackPackageResponse;
}

const ParcelContent: React.FC<IParcelContent> = ({ trackingInfo }) => {
    // const parcels: IParcelItem[] = trackingInfo?.parcels ?? [];

    // if (!parcels.length) return null;

    return (
        <Container>
            <Title>Parcel Content</Title>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeader>Parcel ID</TableHeader>
                        <TableHeader>Item Name</TableHeader>
                        <TableHeader align='right'>Weight</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* {parcels.map((item, index) => ( */}
                        <TableRow >
                            <TableData>{trackingInfo?.packageId}</TableData>
                            <TableData>{trackingInfo?.name}</TableData>
                            <TableData align='right'>{trackingInfo?.weight}kg</TableData>
                        </TableRow>
                    {/* ))} */}
                </TableBody>
            </Table>
        </Container>
    );
};

export default ParcelContent;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 10px;
  overflow: hidden;
  padding: 24px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
  padding-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHead = styled.thead`
  background-color: ${({ theme }) => theme.palette.offWhite};
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};

  &:last-of-type {
    border-bottom: none;
  }
`;

interface CellProps {
    align?: 'left' | 'right' | 'center';
}

const TableHeader = styled.th<CellProps>`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  text-align: ${({ align }) => align ?? 'left'};
`;

const TableData = styled.td<CellProps>`
  padding: 16px 24px;
  font-size: 15px;
  color: #1f2937;
  text-align: ${({ align }) => align ?? 'left'};
`;
